<template>
    <div class="sub">
		<div class="row">
			<el-button type="primary" @click="decode">Decode</el-button>
			<el-button type="primary" @click="coverDecode">Cover Decode</el-button>
			<el-button type="info" @click="encode">Encode</el-button>
		</div>
		<el-input type="textarea" placeholder="input your text..." autofocus v-model="input" :rows="8"></el-input>
		<div class="el-icon-sort transform"></div>
		<el-input type="textarea" v-model="output" :rows="8"></el-input>
    </div>


</template>

<script>
export default {
	data() {
		const prefix = '';
		const prefixLen = prefix.length;
		return {
			input:'',
			output:'',
			prefix,
			prefixLen,
		};
	},
	methods: {
		async decode(){
			this.handleInput();
			// this.output = await this.$post('/subidTransform/decode',{input:this.input})
			this.output = this._batchHandle(this.input, this.toDecode);
		},
		async coverDecode() {
			this.handleInput();
			// this.output = await this.$post('/subidTransform/decode',{input:this.input})
			this.output = this._batchHandle(this.input, this.toCoverDecode);
		},
		async encode(){
			this.handleInput();
			// this.output = await this.$post('/subidTransform/encode',{input:this.input})
			this.output = this._batchHandle(this.input, this.toEncode);
		},
		handleInput(){
			this.input = this.input.trim();
		},
		toEncode(text){
			text = text.toString();
			text = text.split("").reverse().join("");
			// text = Buffer.from(text).toString('base64');
			text = this.rot13(text);
			return this.prefix + text;
		},
		toDecode(text){
			text = text.toString();
			if (text.slice(0, this.prefixLen) !== this.prefix) {
				return text;
			}
			text = text.slice(this.prefixLen);
			text = this.rot13(text);
			// text = Buffer.from(text, 'base64').toString('utf8');
			text = text.split("").reverse().join("");
			return text;
		},
		toCoverDecode(text) {
			text = text.toString().replace(/^[0-9]{4}/, '');
			if (text.slice(0, this.prefixLen) !== this.prefix) {
				return text;
			}
			text = text.slice(this.prefixLen);
			text = this.rot13(text);
			// text = Buffer.from(text, 'base64').toString('utf8');
			text = text.split("").reverse().join("");
			return text;
		},
		rot13(text){
			const input     = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ|=_-0123456789';
			const output = input.split("").reverse().join("");
			const index = (x) => input.indexOf(x);
			const translate = (x) => index(x) > -1 ? output[index(x)] : x;
			return text.split('').map(translate).join('');
		},
		_batchHandle(text, fn){
			const rowP = /[^,\s\n\r]+[,\s\n\r]*/g;
			const subP = /[^,\s\n\r]+/;
			let match = text.match(rowP);
			if (!match) {
				return '';
			}
			match = match.map(function(row) {
				const sub = row.match(subP)[0];
				return row.replace(subP, fn(sub));
			});
			return match.join('');
		}

	}
};
</script>
<style scoped>
.row{
	display: row;
	width:100%;
	justify-content: space-around;

}
.sub{
	display:flex;
	flex-direction: column;
	width: 600px;
	align-items: center;
	margin-left:60px;
	margin-top:60px;
}
.transform{
	font-size: 26px;
}
</style>
